import axios from "axios";
import { toast } from "react-toastify";
import api from ".";

export async function openFileInNewTab(fileId: string, tenantId: string) {
  try {
    const { data } = await api.file.getFilePresignedDownloadUrl(fileId, tenantId);
    if (data.result) {
      window.open(data.result.presignedUrl, "_blank");
    }
  } catch (e) {
    if (axios.isAxiosError(e)) {
      if (e.response?.data) {
        toast.error(e.response?.data.errorMessage);
      }
    } else {
      console.log(e);
      toast.error(
        "Something really went wrong, you might want to contact support!"
      );
    }
  }
}